import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlideAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slide-add"><path d="M17.25 6.86111V2.75H2.75V17.25H6.75M14.0556 10.75V14.0556M14.0556 14.0556V17.25M14.0556 14.0556H10.75M14.0556 14.0556H17.25M6.75 6.86111H21.25V21.25H6.75V6.86111Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSlideAdd;
